import { useSetAtom } from 'jotai';

import { currentConversationIdAtom, historyDrawerOpenAtom } from '../state';

export const useHeaderActions = () => {
  const setCurrentConversationId = useSetAtom(currentConversationIdAtom);
  const setOpenHistoryDrawer = useSetAtom(historyDrawerOpenAtom);

  const handleNewConversation = () => {
    setCurrentConversationId(null);
  };

  const handleOpenHistoryDrawer = () => {
    setOpenHistoryDrawer(true);
  };

  return { handleNewConversation, handleOpenHistoryDrawer };
};
